import * as React from 'react';
import { UIText2 } from '@cian/ui-kit/typography';

import { Link } from '../Link';

import * as styles from './styles.css';
import { ReactElement } from 'react';

interface IPromosPreviewProps {
  title: string;
  morePromos: string | null;
  morePromosLink: string;
  promoItems: ReactElement[];
  onClick: () => void;
}

export function PromosPreview({ title, morePromos, promoItems, morePromosLink, onClick }: IPromosPreviewProps) {
  const displayPromoItems = React.useMemo(() => [...promoItems].reverse(), [promoItems]);

  return (
    <div data-testid="PromosPreview" className={styles['container']}>
      <div className={styles['content']}>
        <UIText2 fontWeight="bold">{title}</UIText2>
        {morePromos && (
          <div className={styles['link']}>
            <Link url={morePromosLink} text={morePromos} onClick={onClick} />
          </div>
        )}
      </div>
      <div className={styles['promo-types']}>{displayPromoItems}</div>
    </div>
  );
}
